import { render } from "./CardItem.vue?vue&type=template&id=5eb79ee8&scoped=true"
import script from "./CardItem.vue?vue&type=script&lang=ts"
export * from "./CardItem.vue?vue&type=script&lang=ts"

import "./CardItem.vue?vue&type=style&index=0&id=5eb79ee8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5eb79ee8"

export default script